import OrderDTO from "@/dto/order/OrderDTO";
import ShopDTO from "@/dto/shop/ShopDTO";
import OrderTag from "@/enum/OrderTag";
import ShopType from "@/enum/ShopType";
import { observer } from "mobx-react-lite";
import React from "react";

interface PddShipHoldTipProps {
    order: OrderDTO;

    shop: ShopDTO;
}

export function shouldRenderPddShipHoldTip(order: OrderDTO, shop: ShopDTO) {
    return shop.type === ShopType.PINDUODUO && !!order.tags?.includes(OrderTag.SHIP_HOLD);
}

const PddShipHoldTip: React.FC<PddShipHoldTipProps> = function (props) {
    const { order, shop } = props;

    if (!shouldRenderPddShipHoldTip(order, shop)) {
        return null;
    }

    return (
        <div>
            <span className="error">
                该订单因发货地疫情影响，暂不支持发货并可能无法获取收货人信息，当疫情限制解除时，订单将展示地址，重启承诺发货时间倒计时并支持发货
            </span>
        </div>
    );
};

export default observer(PddShipHoldTip);
